interface Props {
	children?: JSX.Element | Array<JSX.Element>;
}

const AppFlowContainer = (props: Props): JSX.Element => {
	const { children } = props;

	return (
		<div className="flex w-screen h-screen bg-background relative">
			<div className="flex w-full h-full relative z-[1]">{children}</div>
		</div>
	);
};

export default AppFlowContainer;
